/**
 * @generated SignedSource<<218c07eacd9646192ac6cf4165e9496e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendTimeRegEmailInput = {
  receiverId?: string | null;
  receiverIds?: ReadonlyArray<string | null> | null;
  dateRange?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type sendTimeRegEmailMutation$variables = {
  input: SendTimeRegEmailInput;
};
export type sendTimeRegEmailMutation$data = {
  readonly sendTimeRegEmail: {
    readonly clientMutationId: string | null;
  } | null;
};
export type sendTimeRegEmailMutation = {
  variables: sendTimeRegEmailMutation$variables;
  response: sendTimeRegEmailMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendTimeRegEmailPayload",
    "kind": "LinkedField",
    "name": "sendTimeRegEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendTimeRegEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendTimeRegEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fc0af86e372107f74ea97a763d4e4c49",
    "id": null,
    "metadata": {},
    "name": "sendTimeRegEmailMutation",
    "operationKind": "mutation",
    "text": "mutation sendTimeRegEmailMutation(\n  $input: SendTimeRegEmailInput!\n) {\n  sendTimeRegEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b35bd489189cf5b35a638cf47fb6e18";

export default node;
